<template>
  <div class="chat-container">
    <div class="welcome-message">
      Pregúntele a Bruno sobre la COP16<br />
      ¡Chatee aquí con él!
    </div>

    <div ref="messageContainer" class="messages">
      <div
        v-for="(message, index) in messages"
        :key="index"
        :class="['message', message.sender === 'Yo' ? 'user-message' : 'bot-message']"
      >
        <img
          v-if="message.sender === 'Bruno'"
          src="../../public/bruno.png"
          alt="Bruno Avatar"
          class="avatar"
        />
        <div class="message-content">
          <template v-if="message.sender === 'Bruno'">
            <strong>{{ message.sender }}:</strong>&nbsp;
          </template>
          <span v-html="message.text.replace(/\n/g, '<br>')"></span>
        </div>
      </div>
      <div v-if="isTyping" class="typing-indicator">
        <img src="../../public/bruno.png" alt="Bruno Avatar" class="avatar" />
        <div class="dots">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="input-area">
      <input
        ref="userInput"
        v-model="userInput"
        @keyup.enter="sendMessage"
        :placeholder="isLoading ? 'Cargando...' : 'Escribe tu mensaje...'"
        :disabled="isLoading"
      />
      <button @click="sendMessage" :disabled="isLoading">Enviar</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userInput: "",
      messages: [],
      isLoading: false,
      isTyping: false,
      userId: this.generateUniqueId(),
    };
  },
  methods: {
    generateUniqueId() {
      return "u" + Math.random().toString(36).substring(2, 15);
    },
    async sendMessage() {
      if (this.userInput.trim() === "" || this.isLoading) return;

      const userMessage = { sender: "Yo", text: this.userInput };
      this.messages.push(userMessage);
      this.userInput = "";
      this.isLoading = true;
      this.isTyping = true;

      try {
        const response = await axios.post(
          "https://stingray-app-x5556.ondigitalocean.app/api/v1/message/bot",
          {
            question: userMessage.text,
            user_id: this.userId,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        const botResponse =
          response.data.data?.response || "Lo siento, no tengo respuesta para eso.";
        this.messages.push({ sender: "Bruno", text: botResponse });
      } catch (error) {
        this.messages.push({
          sender: "Bruno",
          text:
            "Error al obtener la respuesta del bot. Por favor intenta nuevamente más tarde.",
        });
      } finally {
        this.isLoading = false;
        this.isTyping = false;

        this.$nextTick(() => {
          this.$refs.userInput.focus();
        });
      }
    },
  },
  mounted() {
    const container = this.$refs.messageContainer;
    container.scrollTop = container.scrollHeight;
  },
  updated() {
    const container = this.$refs.messageContainer;
    container.scrollTop = container.scrollHeight;
  },
};
</script>

<style>
.chat-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
}

.welcome-message {
  text-align: center;
  color: #4caf50;
  padding: 10px;
  border-radius: 8px;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: bold;
}

.messages {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  padding-right: 10px;
}

.message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  word-wrap: break-word;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-width: 80%;
  text-align: justify;
}

.bot-message {
  background-color: #e0e0e0;
  margin-right: auto;
}

.user-message {
  background-color: #4caf50;
  color: white;
  margin-left: auto;
}

.message-content {
  max-width: 100%;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.typing-indicator {
  display: flex;
  align-items: center;
}

.dots {
  display: flex;
  justify-content: space-between;
  width: 20px;
}

.dots div {
  width: 6px;
  height: 6px;
  background-color: #555;
  border-radius: 50%;
  animation: blink 1s infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.input-area {
  display: flex;
  align-items: center;
}

input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  margin-right: 10px;
}

button {
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #4caf50;
  color: white;
}

button:hover {
  background-color: #388e3c;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .chat-container {
    padding: 10px;
    height: 70vh;
  }

  input {
    padding: 8px;
  }

  button {
    padding: 8px;
  }

  .message {
    max-width: 90%;
  }
}
</style>
